const getEnv = (key: string): string => (import.meta as any).env?.[key] || ""

export const env = {
  apiUrl: getEnv("VITE_API_URL"),
  reportsApiUrl: getEnv("VITE_REPORTS_API_URL"),
  basePath: getEnv("VITE_BASE_PATH"),
  buildEnv: getEnv("VITE_BUILD_ENV"),
}
